import { __assign } from "tslib";
import { useReducer, useRef, useEffect } from 'react';
import { getDefaultComponentData } from '../../types';
import { LayoutRadioValueMapping } from './types';
var defaultState = getDefaultComponentData();
var setStyles = function (store, styles) {
    var data = store.get('componentData') || defaultState;
    return store.update('componentData', __assign(__assign({}, data), { styles: __assign(__assign({}, data.styles), styles) }));
};
function settingsReducer(state, action) {
    switch (action.type) {
        case 'setLayout':
            return __assign(__assign({}, state), { galleryLayout: action.galleryLayout });
        case 'setCrop':
            return __assign(__assign({}, state), { cropping: action.cropping });
        case 'setGridItemWidth':
            return __assign(__assign({}, state), { gridItemWidth: action.width });
        case 'setGridItemHeight':
            return __assign(__assign({}, state), { gridItemHeight: action.height });
        case 'setMasonryRowHeight':
            return __assign(__assign({}, state), { masonryRowHeight: action.height });
        case 'setSpacing':
            return __assign(__assign({}, state), { spacing: action.spacing });
        default:
            throw new Error();
    }
}
export default function useSettingsState(componentData, pubsub, helpers) {
    var _a, _b, _c, _d, _e, _f;
    var initialState = useRef({
        galleryLayout: ((_a = componentData === null || componentData === void 0 ? void 0 : componentData.styles) === null || _a === void 0 ? void 0 : _a.galleryLayout) || defaultState.styles.galleryLayout,
        cropping: ((_b = componentData === null || componentData === void 0 ? void 0 : componentData.styles) === null || _b === void 0 ? void 0 : _b.cropping) || defaultState.styles.cropping,
        gridItemWidth: ((_c = componentData === null || componentData === void 0 ? void 0 : componentData.styles) === null || _c === void 0 ? void 0 : _c.gridItemWidth) || defaultState.styles.gridItemWidth,
        gridItemHeight: ((_d = componentData === null || componentData === void 0 ? void 0 : componentData.styles) === null || _d === void 0 ? void 0 : _d.gridItemHeight) ||
            defaultState.styles.gridItemHeight,
        masonryRowHeight: ((_e = componentData === null || componentData === void 0 ? void 0 : componentData.styles) === null || _e === void 0 ? void 0 : _e.masonryRowHeight) ||
            defaultState.styles.masonryRowHeight,
        spacing: ((_f = componentData === null || componentData === void 0 ? void 0 : componentData.styles) === null || _f === void 0 ? void 0 : _f.spacing) || defaultState.styles.spacing,
    });
    var _g = useReducer(settingsReducer, initialState.current), state = _g[0], dispatch = _g[1];
    // Because it's possible to click the floating toolbar while this modal is open, we
    // should be able to catch updates to the component data and update the modal state accordingly.
    useEffect(function () {
        pubsub.subscribe('componentData', updateState);
        return function () {
            pubsub.unsubscribe('componentData', updateState);
        };
    });
    var updateState = function (newComponentData) {
        var _a;
        dispatch({
            type: 'setLayout',
            galleryLayout: ((_a = newComponentData === null || newComponentData === void 0 ? void 0 : newComponentData.styles) === null || _a === void 0 ? void 0 : _a.galleryLayout) || state.galleryLayout,
        });
    };
    var setGalleryLayout = function (e) {
        var galleryLayout = LayoutRadioValueMapping[e.target.value];
        dispatch({ type: 'setLayout', galleryLayout: galleryLayout });
        setStyles(pubsub.store, { galleryLayout: galleryLayout });
    };
    var setCropRules = function (e) {
        var cropping = e.target.value;
        dispatch({ type: 'setCrop', cropping: cropping });
        setStyles(pubsub.store, { cropping: cropping });
    };
    var setGridItemWidth = function (e) {
        var width = parseInt(e.target ? e.target.value : e);
        dispatch({
            type: 'setGridItemWidth',
            width: width,
        });
        setStyles(pubsub.store, { gridItemWidth: width });
    };
    var setGridItemHeight = function (e) {
        var height = parseInt(e.target ? e.target.value : e);
        dispatch({
            type: 'setGridItemHeight',
            height: height,
        });
        setStyles(pubsub.store, { gridItemHeight: height });
    };
    var setMasonryRowHeight = function (e) {
        var height = parseInt(e.target ? e.target.value : e);
        dispatch({
            type: 'setMasonryRowHeight',
            height: height,
        });
        setStyles(pubsub.store, { masonryRowHeight: height });
    };
    var setSpacing = function (e) {
        var spacing = parseInt(e.target ? e.target.value : e);
        dispatch({
            type: 'setSpacing',
            spacing: spacing,
        });
        setStyles(pubsub.store, { spacing: spacing });
    };
    var onCancel = function () {
        // Seems that the `closeModal` call renders the gallery block with stale componentData
        // even if we just called `setStyles`. Wrapping on a timer solves the problem.
        setStyles(pubsub.store, initialState.current);
        setTimeout(function () { return helpers.closeModal(); });
    };
    return {
        state: state,
        setGalleryLayout: setGalleryLayout,
        setCropRules: setCropRules,
        setGridItemWidth: setGridItemWidth,
        setGridItemHeight: setGridItemHeight,
        setMasonryRowHeight: setMasonryRowHeight,
        setSpacing: setSpacing,
        onCancel: onCancel,
    };
}
//# sourceMappingURL=useSettingsState.js.map